import React, { useState, useEffect, useContext } from 'react';
import { IoCloseSharp } from "react-icons/io5";
import { motion } from 'framer-motion';
import ButtonWhite from '../../button/ButtonWhite';
import ButtonBack from '../../button/ButtonBack';
import ModalAlert from '../ModalAlert'
import SingleQR from "../../layouts/home/depositar/SingleQR";
import axios from 'axios';


import { formatMontoCop } from '../../../utils/FormatBalanceCop'
import { formatCurrency } from '../../../utils/FormatCurrency'



import SelectWallet from '../../layouts/home/depositar/SelectWallet';
import SelectSend from '../../layouts/home/send/selectSend';
import FastSend from '../../layouts/home/send/fastSend';
import MultiSend from '../../layouts/home/send/multiSend';
import MultisendDetail from '../../layouts/home/send/multisendDetail';



import CreateAccountBank from '../../layouts/home/send/createAccountBank'

import { AuthContext } from '../../../context/AuthContext';
import moment from 'moment';
import { getHashKey } from '../../../functions/createSignImages';

import { ReactComponent as Check } from '../../../assets/IconsColurs/IconsGeneral/checkFilled.svg'

import Cop from '../../../assets/currency/copu.png';
import Usd from '../../../assets/currency/usd.png';
import { UtilContext } from '../../../context/UtilContext';



const ModalSend = ({
    MovementsList,
    quote = false,
    activeDepositar,
    currencyCoin = '',
    balanceCop,
    balanceUsd,
    setActiveDepositar,
    balanceWalletCop,
    balanceWalletUsd,
    WalletBalanceHome,
}) => {
    const { getAuthenticatedHeaders, DetailUser } = useContext(AuthContext);
    const { longitude, latitude, IP } = useContext(UtilContext);

    const [ModalActive, setModalActive] = useState(false);
    const [AccountCountry, setAccountCountry] = useState("");
    const [ammountPreview, setAmmountPreview] = useState(0)

    const [title, setTitle] = useState("")
    const [description, setDescription] = useState("")
    const [users, setUsers] = useState([]);
    const [usersList, setUsersList] = useState([]);
    const [selectMethod, setSelectMethod] = useState(null);
    const [checkbooksList, setCheckbooksList] = useState({});


    const [loadingUser, setLoadingUser] = useState(false);
    const [errorUser, setErrorUser] = useState('');


    const [paso, setPaso] = useState("inicial");
    const [activeButton, setActiveButton] = useState('usuario');
    const [BankUserList, setBankUserList] = useState([]);

    const [controller, setController] = useState(null);

    const [walletCop, setWalletCop] = useState(true);
    const [activeButtonMultiSend, setActiveButtonMultiSend] = useState('usuario');


    const [CurrencyFast, setCurrencyFast] = useState(currencyCoin !== "" ? currencyCoin : "COP");

    const [GMF, setGMF] = useState("");
    const [TotalReceibe, setTotalReceibe] = useState("");


    const [buttonActive, setButtonActive] = useState(false)
    const [bank, setBank] = useState(null)


    const [listCountry, setListCountry] = useState([])
    const [currencyList, setCurrencyList] = useState([

        {
            code: "COP",
            name: "COP"
        },
        {
            code: "USD",
            name: "USD"
        }
    ])




    const [FeeIvaAmount, setFeeIvaAmount] = useState("")
    const [FeeAmount, setFeeAmount] = useState("")
    const [TotalPaid, setTotalPaid] = useState("")

    /* transferencia PSE */

    const [country, setCountry] = useState("+57")


    const [montoPSE, setMontoPSE] = useState("")
    const [correo, setCorreo] = useState('')
    const [phone, setPhone] = useState('')
    const [username, setUsername] = useState('')
    const [wire, setWire] = useState('')



    const [numDocument, setNumDocument] = useState('')

    const [montoPSError, setMontoPSEError] = useState('')
    const [correoError, setCorreoError] = useState(false)
    const [correoValid, setCorreoValid] = useState(false)
    const [phoneError, setPhoneError] = useState(false)
    const [numDocumentError, setNumDocumentError] = useState(false)

    const [banckErroPSE, setBackErrorPSE] = useState(false)

    const [resumen, setResumen] = useState(false)
    const [isVisible, setIsVisible] = useState(false);
    const [finalTransactionPSE, setFinalTransactionPSE] = useState(false)
    const [alertFinistTransfert, setAlertFinistTransfert] = useState(false)
    const [rountingNum, setRountingNum] = useState("")

    const [errorMessagePSE, setErrorMessagePSE] = useState('')

    // Estado para rastrear el paso anterior
    const [previousStep, setPreviousStep] = useState(null)

    useEffect(() => {
        // Actualiza el estado de error solo cuando `correoValid` cambia
        setCorreoError(!correoValid);
    }, [correoValid]);


    /* varibles compra PSE */

    const [montoCompra, setMontoCompra] = useState('')
    const [comisionCompra, setComisionCompra] = useState('')
    const [ivaCompra, setIvaCompra] = useState('')
    const [totalCompra, setTotalCompra] = useState('')

    /* Transferencia bancaria */
    const [voucherBanck, setVoucherBanck] = useState(false)
    const [closeTransfert, setCloseTransfert] = useState(false)
    const [finishTransfert, setFinishTransfert] = useState(false)

    const [banck, setBack] = useState('')

    const [loading, setLoading] = useState(false)
    const [loadingBank, setLoadingBank] = useState(false)

    const [currency, setCurrency] = useState('COP')
    const [montoTransfert, setMontoTransfert] = useState('')
    const [evidencia, setEvidencia] = useState(null)
    const [banckArray, setBanckArray] = useState([])

    const [banckError, setBackError] = useState(false)
    const [currencyError, setCurrencyError] = useState(false)
    const [montoTransfertError, setMontoTransfertError] = useState(false)
    const [evidenciaError, setEvidenciaError] = useState(false)

    const [selectBanck, setSelectBanck] = useState(false)
    const [selectBanckError, setSelectBanckError] = useState(false)


    const [errorMessage, setErrorMessage] = useState('')
    const [errorMessageBank, setErrorMessageBank] = useState('')


    const [listCurrency, setListCurrency] = useState([])
    const [transitionBack, setTransitionBack] = useState(false)

    const [loadingAddressQr, setLoadingAddressQr] = useState(false)
    const [addressQrUSDC, setAddressQrUSDC] = useState('')
    const [addressQrUSDT, setAddressQrUSDT] = useState('')
    const [loadingResumenPSE, setLoadingResumenPSE] = useState(false)

    let phonePSE = country + phone
    const [nombres, setNombres] = useState('');
    const [apellidos, setApellidos] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState(0);
    const [documento, setDocumento] = useState('');
    const [bancoSeleccionado, setBancoSeleccionado] = useState(null);
    const [listaBancos, setListaBancos] = useState(
        [
            { name: "Agrario", code: 8 },
            { name: "AV Villas", code: 12 },
            { name: "Bancolombia", code: 0 },
            { name: "Bancoomeva", code: 15 },
            { name: "BBVA", code: 3 },
            { name: "BCSC", code: 9 },
            { name: "Banco Bogota", code: 1 },
            { name: "Caja Social", code: 34 },
            { name: "Citybank", code: 11 },
            { name: "Colpatria", code: 5 },
            { name: "Coltefinanciera", code: 24 },
            { name: "Confiar", code: 31 },
            { name: "Cooperativa Financiera de Antioquia", code: 29 },
            { name: "Cooperativo Coopcentral", code: 26 },
            { name: "Cootrafa Cooperativa Financiera", code: 32 },
            { name: "Davivienda", code: 2 },
            { name: "Daviplata", code: 19 },
            { name: "Falabella", code: 17 },
            { name: "Finandina", code: 20 },
            { name: "Financiera Juriscoop SA", code: 30 },
            { name: "GNB Sudameris", code: 33 },
            { name: "Helm", code: 7 },
            { name: "Itau", code: 21 },
            { name: "Itau Corbanca", code: 22 },
            { name: "Lulo Bank", code: 23 },
            { name: "Nequi", code: 18 },
            { name: "NU", code: 35 },
            { name: "Occidente", code: 4 },
            { name: "Popular", code: 6 },
            { name: "Pichincha", code: 14 },
            { name: "Procredit", code: 13 },
            { name: "RappiPay", code: 28 },
            { name: "Santander", code: 16 },
            { name: "UALA", code: 25 },
        ],

    )
    const [listaBancosEEUU, setListaBancosEEUU] = useState([
        { "name": "Bank of America", "code": 103 },
        { "name": "JPMorgan Chase", "code": 104 },
        { "name": "Citigroup", "code": 105 },
        { "name": "Wells Fargo", "code": 106 },
        { "name": "Goldman Sachs", "code": 107 },
        { "name": "Morgan Stanley", "code": 108 },
        { "name": "US Bancorp", "code": 109 },
        { "name": "PNC Financial Services", "code": 110 },
        { "name": "TD Bank NA", "code": 111 },
        { "name": "Truist Financial", "code": 112 },
        { "name": "Capital One", "code": 113 },
        { "name": "Charles Schwab Corporation", "code": 114 },
        { "name": "The Bank of New York Mellon", "code": 115 },
        { "name": "State Street Corporation", "code": 116 },
        { "name": "BMO USA", "code": 117 },
        { "name": "American Express", "code": 118 },
        { "name": "HSBC Bank USA", "code": 119 },
        { "name": "USAA", "code": 120 },
        { "name": "First Citizens Bancshares", "code": 121 },
        { "name": "Citizens Financial Group", "code": 122 },
        { "name": "Fifth Third Bank", "code": 123 },
        { "name": "M&T Bank", "code": 124 },
        { "name": "UBS", "code": 125 },
        { "name": "Huntington Bancshares", "code": 126 },
        { "name": "Ally Financial", "code": 127 },
        { "name": "Barclays", "code": 128 },
        { "name": "KeyCorp", "code": 129 },
        { "name": "Ameriprise", "code": 130 },
        { "name": "Santander Bank", "code": 131 },
        { "name": "RBC Bank", "code": 132 },
        { "name": "Regions Financial Corporation", "code": 133 },
        { "name": "Northern Trust", "code": 134 },
        { "name": "Discover Financial", "code": 135 },
        { "name": "Synchrony Financial", "code": 136 },
        { "name": "Deutsche Bank", "code": 137 },
        { "name": "New York Community Bank", "code": 138 },
        { "name": "Mizuho Financial Group", "code": 139 },
        { "name": "Raymond James Financial", "code": 140 },
        { "name": "First Horizon National Corporation", "code": 141 },
        { "name": "Western Alliance Bancorporation", "code": 142 },
        { "name": "Comerica", "code": 143 },
        { "name": "Webster Bank", "code": 144 },
        { "name": "CIBC Bank USA", "code": 145 },
        { "name": "East West Bank", "code": 146 },
        { "name": "Popular Inc", "code": 147 },
        { "name": "BNP Paribas", "code": 148 },
        { "name": "Silicon Valley Bank", "code": 149 },
        { "name": "Signature Bank", "code": 150 },
        { "name": "Zions Bancorporation", "code": 151 },
        { "name": "Frost Bank", "code": 152 }
    ])

    const [errorBanco, setErrorBanco] = useState(false);
    const [errorADDBank, setErrorADDBank] = useState('');

    const [numeroCuenta, setNumeroCuenta] = useState('');
    const [numeroRuta, setNumeroRuta] = useState('');
    const [tipoCuenta, setTipoCuenta] = useState(null);
    const [nombreCuenta, setNombreCuenta] = useState('');

    // Variables para cuentas bancarias en multi send
    const [bankAccounts, setBankAccounts] = useState([]);
    const [selectedBank, setSelectedBank] = useState(null);

    const OnClose = () => {
        setSelectMethod(null)
        setCorreoError(false)
        setPhoneError(false)
        setNumDocumentError(false)
        setMontoPSEError('')
        setBanckArray([])
        setErrorMessage('')
        setSelectBanckError(false)
        setErrorMessageBank(false)
        setBackError(false)
        setCurrencyError(false)
        setMontoTransfertError(false)
        setEvidenciaError(false)
        setMontoPSE('')
        setCorreo('')
        setNumDocument('')
        setPhone('')
        setBankAccounts([])
        setSelectedBank(null)
        setPreviousStep(null)

        setVoucherBanck(false)
        setFinishTransfert(false)

        setBack('')
        setCurrency('')
        setMontoTransfert('')
        setEvidencia(null)
        setButtonActive(false)

        setBank(null)
        setSelectBanck(false)
        setIsVisible(false)
        setPaso("inicial")
        setActiveDepositar(false)
    };






    const handleUSDBankTransfer = async () => {
        setLoading(true);
        let deposit_option = "";
        if (selectMethod === 'banco') {
            deposit_option = "RTP , BANK";
        } else if (selectMethod === 'paypal') {
            deposit_option = "PAYPAL";
        } else if (selectMethod === 'venmo') {
            deposit_option = "VENMO";
        }

        const paymentData = {
            "deposit_option": deposit_option,
            "currency": "USD",
            "amount": montoPSE,
            "ip": IP,
            "latitude": String(latitude),
            "longitude": String(longitude)
        };

        try {
            const paymentResponse = await axios.post('/api/checkbooks/owner/payment', {
                headers: await getAuthenticatedHeaders(),
                data: paymentData
            });

            if (paymentResponse.data.status === 201) {
                const { check_id, withdraw_id } = paymentResponse.data.data;

                const depositData = {
                    "check_id": check_id,
                    "account_id": bank.account_id,
                    "withdraw_id": withdraw_id
                };

                const depositResponse = await axios.post('/api/checkbooks/owner/deposit', {
                    headers: await getAuthenticatedHeaders(),
                    data: depositData
                });

                if (depositResponse.data.status === 201) {
                    setModalActive(true);
                    setTitle("¡Envío exitoso!");
                    setDescription("La transferencia se ha realizado con éxito");
                } else {
                    setErrorMessagePSE(depositResponse.data?.data?.message || 'Error al finalizar la transacción.');
                }

            } else {
                setErrorMessagePSE(paymentResponse.data?.data?.message || 'Error al crear el ID de la transacción.');
            }
        } catch (error) {
            console.error("Error en la transacción de USD", error);
            setErrorMessagePSE('No se pudo completar la transacción. Intente nuevamente.');
        } finally {
            setLoading(false);
        }
    };



    const NextPaso = () => {
        if (paso === "send_fast") {
            if (activeButton === "usuario") {
                SendFinal()
            } else {
                if (CurrencyFast === 'USD') {
                    handleUSDBankTransfer();
                } else {
                    SendFinalBank();
                }
            }


        } else if (paso === "multi_send") {
            SendDetailMulti()
        } else if (paso === "preview_multi_send") {
            SendMulti()
        } else if (paso === "add_bank") {
            CreateBankAccount()
        }
    }





    const BackTransfert = () => {
        if (paso === "send_fast" || paso === "select_currency" || paso === "upload_file") {
            setPaso("inicial")
        } else if (paso === 'multi_send') {
            setPaso("select_currency")
        } else if (paso === 'preview_multi_send') {
            setPaso("multi_send")
        } else if (paso == "add_bank") {
            setPaso(previousStep || "send_fast")
            setPreviousStep(null)
        }
    }






    /* consumo del flujo de Transferencia Bancarias */
    const SendFinal = async () => {
        setLoading(true)
        const data = {
            "currency": CurrencyFast,
            "amount": montoPSE,
            "send_channel": "COLURS",
            "ip": IP,
            "longitude": longitude,
            "latitude": latitude,
            "to_user": correo



        }

        await axios
            .post(`/api/send_fast`, {
                headers: await getAuthenticatedHeaders(),
                data
            })
            .then((response) => {
                console.log("response.ajajajja", response.data?.data?.code_transaction);


                if (response.data.status === 201) {
                    setModalActive(true)
                    setTitle("¡Envío exitoso!")
                    setDescription("La transferencia se ha realizado con éxito")
                    setActiveDepositar(false)
                } else if (response.data.status === 404) {
                    if (response.data?.data?.code_transaction === "ToUserNotExist") {
                        setIsVisible(false)
                        setErrorMessagePSE("El usuario no existe.")
                        setCorreoError(true)

                    }

                }
            })


            .catch((error) => {
                console.log("error", error);


                setLoading(false)
                console.log(error)
            });

        setLoading(false)

    }

    const SendDetail = async () => {
        setLoadingResumenPSE(true)
        const data = {
            "currency": CurrencyFast,
            "amount": montoPSE,
            "send_channel": activeButton === "usuario" ? "COLURS" : "DALE",
            "ip": IP,
            "longitude": longitude,
            "latitude": latitude,
            "is_for_quote": quote



        }

        await axios
            .post(`/api/detail_send`, {
                headers: await getAuthenticatedHeaders(),
                data
            })
            .then((response) => {

                if (response.data.status === 200) {
                    setIsVisible(true)
                    setTotalReceibe(response.data.data.result.payed_amount)
                    setGMF(response.data.data.result.gmf_amount)
                    setFeeAmount(response.data.data.result.fee_amount)
                    setFeeIvaAmount(response.data.data.result.fee_iva_amount)
                    setTotalPaid(response.data.data.result.total_paid)

                } else if (response.data.status === 400) {
                    if (response.data?.data?.non_field_errors[0] == "The available balance is less than the amount deposited") {
                        setIsVisible(false)
                        setMontoPSEError("Saldo Insuficiente. Ingresa otro valor o recarga tu billetera y vuelve a intentarlo.")
                    }

                }
            })

            .catch((error) => {


                setLoadingResumenPSE(false)
                console.log(error)
            });

        setLoadingResumenPSE(false)

    }

    const SendFinalBank = async () => {
        setLoading(true)
        const data = {
            "dispersions": [
                {
                    "third_party_bank_id": bank.pk,
                    "amount": montoPSE
                }
            ],
            "currency": CurrencyFast,
            "longitude": String(longitude),
            "latitude": String(latitude),
            "platform": "PANEL"
        }

        await axios
            .post(`/api/third_party_withdraw`, {
                headers: await getAuthenticatedHeaders(),
                data
            })
            .then((response) => {

                if (response.data.status === 201) {
                    setModalActive(true)
                    setTitle("Transferencia exitosa")
                    setDescription("En pocos minutos el movimiento se verá reflejados en tu cuenta Colurs")

                } else if (response.data.status === 400) {

                    console.log(response.data.data.message === 'El balance es insuficiente.', 'RESPUESTA');

                    if (response.data.data.message === 'El balance es insuficiente.') {
                        setIsVisible(false)
                        setErrorMessagePSE("No tiene el saldo suficiente para realizar la transferencia.")
                        setCorreoError(true)
                        return
                    } else {
                        setIsVisible(false)
                        setErrorMessagePSE("Lo sentimos, estamos presentando problemas en estos momentos. Por favor, inténtalo de nuevo más tarde.")
                        setCorreoError(true)
                    }



                }
            })

            .catch((error) => {
                setLoading(false)
                console.log(error)
            });

        setLoading(false)

    }


    function validarCorreo(correo) {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(correo);
    }
    const isUsernameInList = (username) => {
        return usersList.some(user => user.username.toLowerCase() === username.toLowerCase());
    };
    const validateUser = async () => {
        setLoadingUser(true)
        let data = {}
        if (isUsernameInList(username)) {
            setErrorUser("El usuario ya está agregado en la lista.")
            setLoadingUser(false)
            return
        }
        if (validarCorreo(username)) {
            data = {
                username: username
            }
        } else {
            data = {
                phone: username
            }
        }


        await axios
            .post(`/api/validate_user`, {
                headers: await getAuthenticatedHeaders(),
                data
            })
            .then((response) => {


                if (response.data.status === 200) {
                    addUser(response.data.data.data.id, response.data.data.data.first_name + " " + response.data.data.data.last_name)
                } else {
                    setErrorUser("Usuario no encontrado")
                }
            })

            .catch((error) => {


                setLoadingUser(false)
                console.log(error)
            });

        setLoadingUser(false)

    }
    const ListBanks = async () => {
        setLoadingUser(true)


        await axios
            .post(`/api/document_list`, {
                headers: await getAuthenticatedHeaders(),
                country: CurrencyFast === "USD" ? "US" : "CO"
            })
            .then((response) => {


                if (response.data.status === 200) {
                    addUser(response.data.data.data.id, response.data.data.data.first_name + " " + response.data.data.data.last_name)
                } else {
                    setErrorUser("Usuario no encontrado")
                }
            })

            .catch((error) => {


                setLoadingUser(false)
                console.log(error)
            });

        setLoadingUser(false)

    }


    const addUser = (id, name) => {
        if (username.trim() !== "") {
            setUsers([...users, { name: name, profile_id: id, send_channel: "COLURS" }]);
            setUsersList([...usersList, { username }]);
            setUsername("");
        }
    };
    const validateBankAccount = () => {
        if (selectedBank) {
            let newAccount;

            if (currency === 'USD') {
                // Para USD, usar el formato de checkbooks
                newAccount = {
                    id: Date.now(), // ID temporal
                    account_id: selectedBank.account_id,
                    account_holder_name: selectedBank.name || selectedBank.account_holder_name,
                    bank_name: selectedBank.payment_method || "ACH",
                    account_number: selectedBank.routing || selectedBank.account || selectedBank.account_number,
                    account_type: selectedBank.type || selectedBank.account_type,
                    deposit_option: selectedBank.payment_method || "ACH",
                    amount: ""
                };
            } else {
                // Para COP, usar el formato existente
                newAccount = {
                    id: Date.now(), // ID temporal
                    thirdpartybank_id: selectedBank.pk,
                    account_holder_name: selectedBank.account_holder_name,
                    bank_name: selectedBank.bank_name,
                    account_number: selectedBank.account_number,
                    account_type: selectedBank.account_type,
                    amount: ""
                };
            }

            setBankAccounts([...bankAccounts, newAccount]);
            setSelectedBank(null);
        }
    };
    const BankListUser = async () => {


        await axios
            .post(`/api/list_third_party_banks`, {
                headers: await getAuthenticatedHeaders(),
                country: "CO"
            })
            .then((response) => {

                if (response.data.status === 200) {
                    setBankUserList(response.data.data.results)


                } else if (response.data.status === 400) {


                    if (response.data?.data?.non_field_errors == "The available balance is less than the amount deposited") {

                        setErrorUser("Saldo Insuficiente. Ingresa otro valor o recarga tu billetera y vuelve a intentarlo.")
                    }
                }
            })

            .catch((error) => {


                setLoadingResumenPSE(false)
                console.log(error)
            });

        setLoadingResumenPSE(false)

    }
    const SendDetailMulti = async () => {
        setLoadingResumenPSE(true)

        // Para USD, ir directamente al envío sin estimación
        if (currency === 'USD' && activeButtonMultiSend === 'banco') {
            setLoadingResumenPSE(false);
            SendMulti();
            return;
        }

        // Determinar si es envío a usuarios o a bancos basado en el contenido de users vs bankAccounts
        let data;
        let endpoint;

        if (activeButtonMultiSend === "usuario") {
            // Envío a usuarios
            data = {
                "currency": currency,
                "ip": IP,
                "longitude": longitude,
                "latitude": latitude,
                "profiles": users
            }
            endpoint = '/api/estimate/multiple-user';
        } else {
            // Envío a bancos COP (USD ya se maneja arriba)
            data = {
                "currency": currency,
                "ip": IP,
                "longitude": longitude,
                "latitude": latitude,
                "profiles": bankAccounts.map(account => ({
                    "profile_id": account.thirdpartybank_id,
                    "amount": account.amount,
                    "send_channel": "DALE"
                }))
            }
            endpoint = '/api/estimate/multiple-user';
        }

        await axios
            .post(endpoint, {
                headers: await getAuthenticatedHeaders(),
                data
            })
            .then((response) => {

                if (response.data.status === 200 || response.data.status === 201) {
                    setIsVisible(true)

                    // Para bancos, usar valores por defecto o de la respuesta
                    setFeeAmount(response.data.data?.result?.fee_amount || 0)
                    setFeeIvaAmount(response.data.data?.result?.fee_iva_amount || 0)
                    setTotalPaid(response.data.data?.result?.total_paid || bankAccounts.reduce((sum, account) => sum + (parseFloat(account.amount) || 0), 0))
                    setAmmountPreview(response.data.data?.result?.amount || bankAccounts.reduce((sum, account) => sum + (parseFloat(account.amount) || 0), 0))

                    setPaso("preview_multi_send")

                } else if (response.data.status === 400) {
                    if (response.data?.data?.non_field_errors == "The available balance is less than the amount deposited") {
                        setErrorUser("Saldo Insuficiente. Ingresa otro valor o recarga tu billetera y vuelve a intentarlo.")
                    }
                }
            })

            .catch((error) => {
                setLoadingResumenPSE(false)
                console.log(error)
            });

        setLoadingResumenPSE(false)

    }
    const SendMulti = async () => {
        setLoading(true)

        // Determinar si es envío a usuarios o a bancos
        const isBankTransfer = bankAccounts.length > 0;

        let data;
        let endpoint;

        if (isBankTransfer) {
            if (currency === 'USD') {
                // Envío a bancos USD usando el nuevo endpoint
                data = {
                    "currency": currency,
                    "ip": IP,
                    "latitude": String(latitude),
                    "longitude": String(longitude),
                    "items": bankAccounts.map(account => ({
                        "amount": account.amount,
                        "deposit_option": account.deposit_option === "ACH" ? "RTP,BANK" : "ACH", // Por defecto ACH
                        "account_id": account.account_id
                    }))
                }
                endpoint = '/api/dispersion-multiple-payout/';
            } else {
                // Envío a bancos COP usando el formato existente
                data = {
                    "dispersions": bankAccounts.map(account => ({
                        "third_party_bank_id": account.thirdpartybank_id,
                        "amount": account.amount
                    })),
                    "currency": currency,
                    "longitude": String(longitude),
                    "latitude": String(latitude),
                    "platform": "PANEL"
                }
                endpoint = '/api/third_party_withdraw';
            }
        } else {
            // Envío a usuarios (formato existente)
            data = {
                "currency": currency,
                "send_channel": "COLURS",
                "ip": IP,
                "longitude": longitude,
                "latitude": latitude,
                "profiles": users
            }
            endpoint = '/api/send/multiple-user';
        }

        await axios
            .post(endpoint, {
                headers: await getAuthenticatedHeaders(),
                data
            })
            .then((response) => {

                if (response.data.status === 201) {
                    CloseModal()
                    setModalActive(true)
                    setTitle("Transferencia exitosa")
                    setDescription("En pocos minutos el movimiento se verá reflejados en tu cuenta Colurs")
                }
            })

            .catch((error) => {
                setLoading(false)
                console.log(error)

                // Manejo específico de errores para USD
                if (currency === 'USD' && isBankTransfer) {
                    if (error.response?.data?.status === 400) {
                        const errorMessage = error.response.data?.data?.message || error.response.data?.data?.error || 'Error en la dispersión USD';

                        if (errorMessage.includes("insufficient")) {
                            setErrorUser("Saldo insuficiente para realizar la dispersión USD");
                        } else if (errorMessage.includes("invalid")) {
                            setErrorUser("Datos de cuenta bancaria inválidos");
                        } else if (errorMessage.includes("limit")) {
                            setErrorUser("Has excedido el límite de dispersión USD");
                        } else {
                            setErrorUser(errorMessage);
                        }
                    } else if (error.response?.status === 500) {
                        setErrorUser("Error del servidor. Intenta nuevamente más tarde");
                    } else if (error.response?.status === 404) {
                        setErrorUser("Servicio de dispersión USD no disponible");
                    } else {
                        setErrorUser("Error al procesar la dispersión USD. Verifica los datos e intenta nuevamente");
                    }
                } else {
                    // Manejo de errores para otros casos
                    setErrorUser("Error al procesar la transacción. Intenta nuevamente");
                }
            });

        setLoading(false)

    }

    const CloseModal = () => {
        setSelectMethod(null)
        setUsers([])
        setUsersList([])
        setUsername("")
        setCorreo("")
        setBankAccounts([])
        setSelectedBank(null)
        setPreviousStep(null)
        WalletBalanceHome()
        MovementsList()
        setMontoPSE("")
        setActiveDepositar(false)
        setPaso("inicial")
        setModalActive(false)
    }

    const modalVariants = {
        hidden: { scale: 0, opacity: 0 },
        visible: {
            scale: 1,
            opacity: 1,
            transition: { duration: 0.5, ease: "easeOut" }
        },
        exit: {
            scale: 0.8,
            opacity: 0,
            transition: { duration: 0.5, ease: "easeInOut" }
        },
    };


    const stepVariants = {
        hidden: transitionBack ? { x: "-100%", opacity: 0 } : { x: "100%", opacity: 0 },
        visible: { x: 0, opacity: 1 },
        exit: transitionBack ? { x: "100%", opacity: 0 } : { x: "-100%", opacity: 0 },
    };



    const ClickWalletCop = () => {

        setCurrency("COP");
        setPaso("multi_send");
    };

    const ClickWalletUsd = () => {
        setCurrency("USD");
        setPaso("multi_send");
    };







    useEffect(() => {

        BankListUser()
        if (
            montoPSE != "" &&
            (
                (montoPSE < 10000 && CurrencyFast === "COP") ||
                (montoPSE < 10 && CurrencyFast === "USD")
            )
        ) {
            setMontoPSEError(`El monto minimo son ${CurrencyFast == "COP" ? "$10,000" : "$10"} ${CurrencyFast}`)
            return
        } else {
            setMontoPSEError("")
        }
        if (!activeDepositar) { return }

        // Cancelar la petición anterior si existe
        if (controller) {
            controller.abort();
        }

        // Crear un nuevo AbortController para la petición actual
        const newController = new AbortController();
        setController(newController);

        // Esperar 500ms antes de ejecutar la petición (debounce)
        const timeout = setTimeout(() => {
            SendDetail(newController.signal);
        }, 500);

        return () => clearTimeout(timeout); // Limpiar el timeout si los valores cambian rápido

    }, [montoPSE, CurrencyFast]);


    useEffect(() => {
        setCorreoError(false)
        setErrorMessagePSE("")
        setErrorUser("")
    }, [username])


    useEffect(() => {
        setCorreoError(false)
        setErrorMessagePSE("")

    }, [correo])

    useEffect(() => {
        if (quote) {
            setActiveButton('banco')
            setPaso("send_fast")
        }
    }, [activeDepositar])

    useEffect(() => {


        setBancoSeleccionado(null)

    }, [paso])




    const CreateBankAccount = async () => {
        setLoading(true)
        let data = {}
        let endpoint = '/api/create_third_party_banks';
        console.log("tipoCuenta", tipoCuenta);

        if (currency === 'USD' && selectMethod === 'banco') {
            endpoint = '/api/checkbooks/bank';
            data = {
                "name": nombres,
                "account": numeroCuenta,
                "routing": rountingNum,
                "account_type": tipoCuenta,
                "payment_method": "ACH"
            }
        } else if (currency === 'USD' && (selectMethod === 'paypal' || selectMethod === 'venmo')) {
            endpoint = '/api/checkbooks/bank';
            data = {
                "username": nombres,
                "payment_method": selectMethod.toUpperCase()
            }
        } else if (currency !== "COP") {

            data = {
                "account_holder_name": `${nombres} ${apellidos}`,
                "account_type": tipoCuenta === "Ahorros" ? 0 : 1,
                "account_holder_document_type": tipoDocumento,
                "account_holder_document": documento,
                "account_number": numeroCuenta,
                "bank_name": bancoSeleccionado,
                "country_registered": "US",
                "wire": wire,
                "routing_number": rountingNum,
            }
        } else {

            data = {
                "account_holder_name": `${nombres} ${apellidos}`,
                "account_type": tipoCuenta === "Ahorros" ? 0 : 1,
                "account_holder_document_type": tipoDocumento,
                "account_holder_document": documento,
                "account_number": numeroCuenta,
                "bank_name": bancoSeleccionado,
                "country_registered": "CO",

            }
        }



        await axios
            .post(endpoint, {
                headers: await getAuthenticatedHeaders(),
                data
            })
            .then((response) => {

                if (response.data.status === 201) {
                    if (endpoint === '/api/checkbooks/bank') {
                        fetchCheckbooks();
                    } else {
                        BankListUser()
                    }
                    setPaso(previousStep || "send_fast")
                    setBancoSeleccionado(null)
                    setPreviousStep(null)

                    setErrorADDBank("")
                } else if (response.data.status === 400) {
                    // Manejo de errores para create_third_party_banks
                    const errorMessage = response.data?.data?.message || 'Error al crear la cuenta';

                    if (errorMessage === 'Invalida numero de cuenta.') {
                        setErrorADDBank("Número de cuenta inválida")
                    } else {
                        setErrorADDBank(errorMessage)
                    }
                }
            })

            .catch((error) => {
                setLoading(false)
                console.log(error)
            });

        setLoading(false)

    }
    const SelectSendCoin = () => {
        if (currencyCoin === "") {
            setPaso("select_currency")

        } else {
            setCurrency(currencyCoin)
            setPaso("multi_send")
        }

    }
    useEffect(() => {
        if (activeButton !== "usuario" && paso === "send_fast") {

            BankListUser()
        }
    }, [activeButton])



    const isMultiSendDisabled = (users.length === 0 && bankAccounts.length === 0) ||
        users.some(user =>
            user.amount === undefined || user.amount === null || user.amount === "" ||
            (currency === "COP" ? user.amount < 10000 : user.amount < 10)
        ) ||
        bankAccounts.some(account =>
            account.amount === undefined || account.amount === null || account.amount === "" ||
            (currency === "COP" ? account.amount < 10000 : account.amount < 10)
        );
    const isButtonDisabled = paso === "send_fast"
        ? montoPSError !== "" || correo === "" || loading
        : paso === "multi_send"
            ? isMultiSendDisabled || loadingResumenPSE
            : false;


    const handleAccountCreate = () => {
        // Guardar el paso actual antes de ir a add_bank
        setPreviousStep(paso)

        // Si estamos en multi_send con USD, establecer automáticamente selectMethod como 'banco'
        if (paso === 'multi_send' && currency === 'USD') {
            setSelectMethod('banco');
        }

        if (currency === 'USD' && selectMethod === 'banco') {
            setTipoCuenta('SAVINGS');
        } else {
            setTipoCuenta('Ahorros');
        }
        setPaso("add_bank")
    }
    const areFieldsFilled = (
        nombres.trim() !== '' &&
        apellidos.trim() !== '' &&
        documento.trim() !== '' &&
        numeroCuenta.trim() !== '' &&
        String(bancoSeleccionado).trim() !== ''
    );

    const areFieldsFilledUSD_User = (
        nombres.trim() !== ''
    );

    const areFieldsFilledUSD = (
        nombres.trim() !== '' &&
        numeroCuenta.trim() !== '' &&
        rountingNum.trim() !== '' &&
        !!tipoCuenta
    );

    // Validación del botón disabled
    const isDisabled =
        loading ||
        loadingResumenPSE ||
        (paso === 'add_bank' && currency === 'USD' && selectMethod === 'banco' && !areFieldsFilledUSD) ||
        (paso === 'add_bank' && currency === 'USD' && (selectMethod === 'paypal' || selectMethod === 'venmo') && !areFieldsFilledUSD_User) ||
        (paso === 'add_bank' && currency !== 'USD' && !areFieldsFilled) ||
        // Mantener lógica para 'send_fast'
        (paso === 'send_fast' &&
            (
                activeButton === 'usuario'
                    ? (montoPSError !== '' || correo.trim() === '')
                    : (montoPSError !== '' || bank === null)
            )
        ) ||
        // Mantener lógica para 'multi_send'
        (paso === 'multi_send' && isMultiSendDisabled);

    useEffect(() => {
        SendDetail()

    }, [activeButton])

    console.log(balanceWalletCop, 'isDisabled');

    const fetchCheckbooks = async () => {
        await axios
            .post(`/api/checkbooks`, {
                headers: await getAuthenticatedHeaders(),
            })
            .then((response) => {
                if (response.data.status === 200) {
                    setCheckbooksList(response.data.data.data)
                }
            })
            .catch((error) => {
                console.log("Error fetching checkbooks list", error)
            })
    }

    useEffect(() => {
        if (paso === 'send_fast' && CurrencyFast === 'USD') {
            fetchCheckbooks();
        }
    }, [paso, CurrencyFast]);

    useEffect(() => {
        if (paso === 'multi_send') {
            // Refrescar lista de bancos para todas las monedas cuando se entra a multi_send
            if (currency === 'USD') {
                fetchCheckbooks();
            } else {
                BankListUser();
            }
        }
    }, [paso, currency]);

    useEffect(() => {
        if (paso === 'multi_send' && activeButton === 'banco') {
            // Refrescar lista de bancos cuando se cambie a modo banco en multi_send
            if (currency === 'USD') {
                fetchCheckbooks();
            } else {
                BankListUser();
            }
        }
    }, [paso, activeButton, currency]);

    return (
        <>
            {ModalActive && <ModalAlert title={title} description={description} onClick={CloseModal} labelButtonWhite={"Listo"} />}

            {activeDepositar && (
                <div className="fixed inset-0 flex items-center justify-center bg-[#0e0e10] bg-opacity-85 z-50 p-3">
                    <motion.div
                        className={paso === "multi_send" ?
                            "bg-[#26262D] rounded-lg min-h-[500px] md:min-h-[700px] shadow-lg w-full max-w-5xl h-auto flex flex-col justify-between overflow-hidden" :
                            "bg-[#26262D] rounded-lg shadow-lg w-full max-w-2xl h-auto flex flex-col justify-between"
                        }
                        variants={modalVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <div className="p-4 sm:p-6">
                            <div className="w-full flex flex-row justify-between">
                                <p className="text-base sm:text-lg font-semibold text-white">
                                    {paso === "multi_send"
                                        ? "Dispersión múltiple"
                                        : paso === 2 && walletCop
                                            ? "Depositar COP"
                                            : paso === 2 && !walletCop
                                                ? "Depositar USD"
                                                : paso === 3
                                                    ? "Recibir usando QR"
                                                    : paso === 4
                                                        ? "Depositar con PSE"
                                                        : paso === 5
                                                            ? "Depositar con USDT/USDC"
                                                            : paso === 6 && voucherBanck === false
                                                                ? "Transferencia bancaria"
                                                                : paso === 6 && voucherBanck === true
                                                                    ? "Transferencia instantánea"
                                                                    : "Enviar"}
                                </p>
                                <IoCloseSharp
                                    size={24}
                                    color={"#b7b7b9"}
                                    onClick={OnClose}
                                    className="cursor-pointer"
                                />
                            </div>
                            <div className="h-[1.5px] w-full bg-[#16161d] mt-4"></div>
                        </div>

                        <div className="flex-grow px-4 sm:px-6 h-full overflow-y-auto max-h-[70vh] md:max-h-[80vh]">

                            {paso === "inicial" && (
                                <motion.div
                                    className="bg-[#26262D]"
                                    variants={modalVariants}
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    transition={{ duration: 0.5, ease: "easeOut" }}
                                >
                                    <SelectSend
                                        FastSendButton={() => setPaso("send_fast")}
                                        GroupSendButton={() => SelectSendCoin()}
                                        ExcelButtonO={() => setPaso("upload_file")}

                                    />
                                </motion.div>
                            )}

                            {paso === "send_fast" && (
                                <motion.div
                                    key="step3"
                                    variants={modalVariants}
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    transition={{ duration: 0.5, ease: "easeOut" }}
                                >
                                    <FastSend
                                        bank={bank}
                                        checkbooksList={checkbooksList}
                                        setSelectMethod={setSelectMethod}
                                        selectMethod={selectMethod}
                                        currencyCoin={currencyCoin}
                                        quote={quote}
                                        TotalReceibe={TotalReceibe}
                                        setBank={setBank}
                                        GMF={GMF}
                                        handleAccountCreate={handleAccountCreate}
                                        setActiveButton={setActiveButton}
                                        activeButton={activeButton}
                                        errorMessagePSE={errorMessagePSE}
                                        correoError={correoError}
                                        FeeIvaAmount={FeeIvaAmount}
                                        loadingResumenPSE={loadingResumenPSE}
                                        isVisible={isVisible}
                                        FeeAmount={FeeAmount}
                                        TotalPaid={TotalPaid}
                                        setMontoPSE={setMontoPSE}
                                        montoPSE={montoPSE}
                                        montoPSError={montoPSError}
                                        setCorreo={setCorreo}
                                        correo={correo}
                                        balanceWalletCop={balanceWalletCop}
                                        balanceWalletUsd={balanceWalletUsd}
                                        currency={CurrencyFast}
                                        setCurrency={setCurrencyFast}
                                        centerImage={walletCop ? Cop : Usd}
                                        ID_user={DetailUser?.email}
                                        qrValue={DetailUser?.email}
                                        BankUserList={BankUserList}
                                    />

                                </motion.div>
                            )}

                            {paso === "select_currency" && (
                                <motion.div
                                    className="bg-[#26262D]"
                                    variants={modalVariants}
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    transition={{ duration: 0.5, ease: "easeOut" }}
                                >
                                    <SelectWallet
                                        ClickWalletCop={ClickWalletCop}
                                        ClickWalletUsd={ClickWalletUsd}

                                        balanceCop={formatCurrency(balanceWalletCop)}
                                        balanceUsd={formatCurrency(balanceWalletUsd)}
                                    />

                                </motion.div>
                            )}
                            {paso === "multi_send" && (
                                <div className="h-full flex w-full">
                                    <motion.div
                                        className=" w-[100%]  min-h-[600px] h-auto flex flex-col justify-between "
                                        variants={modalVariants}
                                        initial="hidden"
                                        animate="visible"
                                        exit="exit"
                                        transition={{ duration: 0.5, ease: "easeOut" }}
                                    >


                                        <MultiSend
                                            activeButtonMultiSend={activeButtonMultiSend}
                                            setActiveButtonMultiSend={setActiveButtonMultiSend}
                                            error={errorUser}
                                            loading={loadingUser}
                                            setUsers={setUsers}
                                            users={users}
                                            validateUser={validateUser}
                                            username={username}
                                            setUsername={setUsername}
                                            currency={currency}
                                            balanceWalletUsd={balanceWalletUsd}
                                            balanceWalletCop={balanceWalletCop}
                                            bankList={currency === 'USD' ? checkbooksList?.ACH : BankUserList}
                                            selectedBank={selectedBank}
                                            setSelectedBank={setSelectedBank}
                                            validateBankAccount={validateBankAccount}
                                            bankAccounts={bankAccounts}
                                            setBankAccounts={setBankAccounts}
                                            handleAccountCreate={handleAccountCreate}
                                        />

                                    </motion.div>
                                </div>
                            )}
                            {paso === "preview_multi_send" && (
                                <motion.div
                                    key="step3"
                                    variants={modalVariants}
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    transition={{ duration: 0.5, ease: "easeOut" }}
                                >
                                    <MultisendDetail
                                        ammountPreview={ammountPreview}
                                        FeeIvaAmount={FeeIvaAmount}
                                        FeeAmount={FeeAmount}
                                        TotalPaid={TotalPaid}
                                    />


                                </motion.div>
                            )}
                            {paso === "upload_file" && (
                                <motion.div
                                    key="step3"
                                    variants={modalVariants}
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    transition={{ duration: 0.5, ease: "easeOut" }}
                                >

                                </motion.div>
                            )}
                            {paso === "add_bank" && (
                                <motion.div
                                    key="step3"
                                    variants={modalVariants}
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    transition={{ duration: 0.5, ease: "easeOut" }}
                                >
                                    <CreateAccountBank
                                        selectMethod={selectMethod}
                                        setWire={setWire}
                                        wire={wire}
                                        listaBancosEEUU={listaBancosEEUU}
                                        rountingNum={rountingNum}
                                        setRountingNum={setRountingNum}
                                        setAccountCountry={setAccountCountry}
                                        AccountCountry={AccountCountry}
                                        currency={currency}
                                        errorADDBank={errorADDBank}
                                        nombres={nombres}
                                        setNombres={setNombres}
                                        apellidos={apellidos}
                                        setApellidos={setApellidos}
                                        tipoDocumento={tipoDocumento}
                                        setTipoDocumento={setTipoDocumento}
                                        documento={documento}
                                        setDocumento={setDocumento}
                                        bancoSeleccionado={bancoSeleccionado}
                                        setBancoSeleccionado={setBancoSeleccionado}
                                        listaBancos={listaBancos}
                                        errorBanco={errorBanco}
                                        numeroCuenta={numeroCuenta}
                                        setNumeroCuenta={setNumeroCuenta}
                                        numeroRuta={numeroRuta}
                                        setNumeroRuta={setNumeroRuta}
                                        tipoCuenta={tipoCuenta}
                                        setTipoCuenta={setTipoCuenta}
                                        nombreCuenta={nombreCuenta}
                                        setNombreCuenta={setNombreCuenta}
                                    />

                                </motion.div>
                            )}

                        </div>

                        {/* Botones en la parte inferior */}
                        {paso !== "inicial" && <div className="px-4 sm:px-6 py-4 sm:mb-6 flex justify-between">
                            {!quote && <ButtonBack
                                onClick={() => BackTransfert()}
                                label={'Volver'}
                                className="text-sm sm:text-base"
                            />}
                            {quote && <div />}
                            <ButtonWhite
                                isDisabled={isDisabled}
                                loading={paso === "send_fast" ? loading : paso === "multi_send" ? loadingResumenPSE : loading}
                                onClick={NextPaso}
                                label={paso === "send_fast" ? "Enviar" : paso === "multi_send" ? "Continuar con la dispersión" : paso === "preview_multi_send" ? "Enviar" : paso === "add_bank" ? "Guardar" : "Enviar"}
                                className="text-sm sm:text-base"
                            />
                        </div>}
                    </motion.div>
                </div>

            )}

        </>
    );
};

export default ModalSend;

